<template>
  <div>
    <div class="columns">
      <div class="level column mgb-0">
        <app-logo readOnly
                  :elementId="emplacement.id"
                  :libelleElement="$t('emplacement.libelleForLogo', { code: emplacement.code })"
                  class="level-left">
        </app-logo>
      </div>
      <div class="column is-10">
        <div class="columns is-multiline">
          <div class="column is-2">
            <b-field :label="$t('emplacement.codeConsultation')"
            custom-class="has-text-link">
              <p class="has-text-default">{{ emplacement.code }} </p>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('emplacement.libelleConsultation')"
                     custom-class="has-text-link">
              <p class="has-text-default">{{ emplacement.libelle }}</p>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('emplacement.agenceConsultation')"
                     custom-class="has-text-link">
              <p class="has-text-default">{{ getAgenceLibelle() }} </p>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('emplacement.descriptionConsultation')"
                     custom-class="has-text-link">
              <p class="has-text-default">{{ emplacement.description }}</p>
            </b-field>
          </div>
          <div v-if="isClient" class="column is-12">
            <b-field :label="$t('clientEmplacement.clientConsultation')">
              <router-link-blank :message="emplacement.client.nomCommercial"
                                 :to="{ name: 'c.bodac.clients/contacts-client',
                params: { id: emplacement.clientId }}">
              </router-link-blank>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/general/Logo';
import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { CLIENT } from '@/configuration/gabed/emplacement/emplacementConf';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    emplacement: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
    appLogo: Logo,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    isClient() {
      return this.emplacement.type === CLIENT;
    },
  },
  methods: {
    getAgenceLibelle() {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === this.emplacement.agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
  },
};
</script>

<style scoped>

</style>
